/** @param {MouseEvent} [e] */
function showDatepicker(e) {
    if (window.innerWidth >= 1024) {
        if (e) e.preventDefault();
    }
    const input = document.getElementById("giftcard-send_date");

    try {
        if (input?.showPicker) {
            input.showPicker();
        } else {
            input?.focus();
            input?.click();
        }
    } catch {
        input?.focus();
    }
}

function updateGiftcardPrice() {
    const price = document.getElementById("giftcard-price");
    const amount = document.getElementById("giftcard-amount");

    if (price && amount) {
        var newPrice = amount.selectedOptions[0];
        price.textContent = newPrice.getAttribute("data-price");
    }
}

function addGiftcardToCart() {
    const amount = document.getElementById("giftcard-amount");
    const from = document.getElementById("giftcard-from");
    const name = document.getElementById("giftcard-name");
    const email = document.getElementById("giftcard-email");
    const emailConfirm = document.getElementById("giftcard-confirm_email");
    const message = document.getElementById("giftcard-message");
    const date = document.getElementById("giftcard-send_date");
    const checkbox = document.getElementById("giftcard-checkbox");
    const my_properties = {};
    var hasError = false;

    if (amount.value === 'default') {
        amount?.classList.add("error");
        hasError = true;
    } else {
        amount?.classList.remove("error");
    }
    if (!checkbox.checked) {
        checkbox?.classList.add("error");
        hasError = true;
    } else {
        checkbox?.classList.remove("error");
    }
    if (email && emailConfirm) {
        if (email.value === "") {
            email?.classList.add("error");
            hasError = true;
        } else {
            email?.classList.remove("error");
        }
        if (email.value != emailConfirm.value) {
            emailConfirm?.classList.add("error");
            hasError = true;
        } else {
            emailConfirm?.classList.remove("error");
            my_properties.receiver_mail = email.value;
        }
    }

    if (from) {
        if (from.value === "") {
            from?.classList.add("error");
            hasError = true;
        } else {
            from?.classList.remove("error");
        }
        my_properties.sender_name = from.value;
    }
    if (name) {
        if (name.value === "") {
            name?.classList.add("error");
            hasError = true;
        } else {
            name?.classList.remove("error");
        }
        my_properties.receiver_name = name.value;
    }
    if (date) {
        if (date.value === "") {
            date?.parentElement?.classList.add("error");
            hasError = true;
        } else {
            date?.parentElement?.classList.remove("error");
        }
        my_properties.send_date = date.value;
    }
    if (message) {
        my_properties.message = message.value;
    }

    if (hasError == false) {
        var variantId = amount.value;

        customAddToCart(variantId, 1, my_properties);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const input = document.getElementById("giftcard-send_date");
    const formattedDate = document.getElementById("giftcard-formatted_send_date");

    input?.addEventListener('change', (e) => {
        const queryDate = new Date(e.target?.value);
        const nowDate = new Date();

        if (queryDate > nowDate) {
            formattedDate.textContent = formatDate(e.target.value);
        } else {
            formattedDate.textContent = "Date invalide";
        }
    });
});